import Layout from "../layouts/LayoutDefault.jsx";
import ContentContainer from "../components/ContentContainer";
import MainContainer from "../components/MainContainer";
import SmallTitleText from "../components/SmallTitleText";
import CreateBandForm from "../components/loggedin/CreateBandForm";

const AddBand = () => {
  return (
    <>
      <Layout
        title="Lägg till musikprojekt"
        description="Lägg till ett musikprojekt gamalt som nytt"
      >
        <MainContainer>
          <ContentContainer>
            <div className="flex justify-between">
              <SmallTitleText text="Lägg till nytt musikprojekt" />
              <a href="/userprofile">
                <button className="btn btn-neutral border border-base-content/20">
                  Tillbaka
                </button>
              </a>
            </div>

            <p className="my-4">
              Här fyller du i den mest grundläggande informationen om ditt
              musikprojekt. Sen under Min profil kommer du kunna välja att lägga
              till mer information, starta blogg och länka till sociala medier
              m.m. Se till att dubbelkolla så namnet blir rätt för det går inte
              att ändra senare.
            </p>
            <div className="bg-base-200 border border-base-content/20 rounded-sm p-2 mt-2">
              <CreateBandForm />
            </div>
          </ContentContainer>
        </MainContainer>
      </Layout>
    </>
  );
};

export default AddBand;
